import { TableCell } from '@mui/material';
import React from 'react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';

/**
 * @component
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Содержимое ячейки
 * @param {boolean} [props.isLess] - Уменьшить отступы (приоритет над isSmall)
 * @param {boolean} [props.isSmall] - Маленькие отступы
 * @param {'text' | 'numeric'} [props.type] - Тип ячейки
 * @param {Object} [props.sx] - Дополнительные MUI стили
 * @returns {JSX.Element} Ячейка таблицы с адаптивными отступами
 *
 */
export default function MyTableCell({ children, isLess, isSmall, type, ...props }) {
  const { isLessTablet } = useBootstrapSize();
  const sxCell = isLessTablet || isLess ? { px: 0.75, py: 0.75 } : { px: isSmall ? 1.5 : 2, py: 1 };

  return (
    <TableCell
      {...props}
      sx={{ textAlign: type == 'numeric' ? 'center' : 'start', ...sxCell, ...props.sx }}>
      {/* sx={{ textAlign: 'start', ...sxCell, ...props.sx }}> */}
      {children}
    </TableCell>
  );
}
